module.exports = __webpack_public_path__ + "img/Page-1 (1).e52521df.svg";